import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import VoucherTypeFormModal from 'src/features/voucherTypes/components/forms/VoucherTypeFormModal';
import { useCreateVoucherType } from 'src/features/voucherTypes/api/useCreateVoucherType';
import { LIST_VOUCHER_TYPES_RESOURCE } from 'src/features/voucherTypes/api/useListVoucherTypes';
import { VOUCHER_TYPE_RESOURCE } from '../../api/useGetVoucherType';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';

interface CreateVoucherTypeFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateVoucherTypeFormModal<TData>({ className }: CreateVoucherTypeFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateVoucherType({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_VOUCHER_TYPES_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [VOUCHER_TYPE_RESOURCE] });
            toast({
                title: formatMessage(voucherTypesMessages.createVoucherTypeSuccess),
                description: formatMessage(voucherTypesMessages.createVoucherTypeSuccessDescription),
            });
        },
    });

    return (
        <VoucherTypeFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, {
                entry: formatMessage(voucherTypesMessages.voucherType).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(voucherTypesMessages.addVoucherTypeSubtitle)}
        />
    );
}

export default CreateVoucherTypeFormModal;
